(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["dealer-locator"]) return;
  try {
    
  var dealers = [...dealerLoc1, ...dealerLoc2, ...dealerLoc3, ...dealerLoc4];

  var map = '';
    var markers = [];
    var autocomplete, pos2 = {};
    var bounds, infoWindow, markerCluster;

    $(document).ready(function () {
        initialize();
        dealerInfo(dealers);

        const input = document.getElementById("location-input");
        var options = {
            componentRestrictions: { country: "nz" },
        };
        autocomplete = new google.maps.places.Autocomplete(input, options);

        $("#search-button").click(function () {
            var filterForDistance = dealers;
            var location = $("#location-input").val();
            if (location.length) {
                var place = autocomplete.getPlace();
                zipcode = place.formatted_address;

                pos2 = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                };
            } else {
                pos2 = null;
            }
            if (pos2) {
                const lat1 = pos2.lat;
                const lng1 = pos2.lng;
                filterForDistance = dealers.filter((dealer) => distance(lat1, lng1, dealer.latitude, dealer.longitude) < 30);
            }
            dealerInfo(filterForDistance);
            setMapOnAll(null);
            markerCluster.clearMarkers();
            markers = [];
            bounds = new google.maps.LatLngBounds();
            for (var d = 0, dl = filterForDistance.length; d < dl; d++) {
                var dealer = filterForDistance[d];
                var address = dealer.address + ", " + dealer.city + ", " + dealer.postcode + ", " + dealer.state;
                var cachedLocation = getFromLocalStorage(address);
                if (cachedLocation) {
                    dealer.latitude = cachedLocation.lat;
                    dealer.longitude = cachedLocation.lng;
                    addMarker(cachedLocation, dealer.title, dealer);
                } else {
                    geocodeDealerAddress(address, dealer);
                }
            }

        });
    });

    var addMarker = function (location, name, dealer) {
        var marker = new google.maps.Marker({
            map,
            position: location,
            title: name,
            idx: dealer.idx
        });

        bounds.extend(marker.getPosition());

        marker.infoWindowContent =
            '<div class="info-window">' +
            '<strong>' + dealer.title + '</strong>' +
            '<br>' +
            'Address: ' + dealer.address + ', ' + dealer.city + ', ' + dealer.postcode + ', ' + dealer.state +
            '<br>' +
            'Phone Number: ' + dealer.phoneNumber +
            '</div>';

        marker.addListener("click", function () {
            var dealerIndex = marker.idx;
            var dealerElement = $("[data-idx="+ dealerIndex+"]");
            dealerElement.click();
        });

        markers.push(marker);
        markerCluster.addMarker(marker);
        map.fitBounds(bounds);
    };

    function initialize() {
        var mapCanvas = document.getElementById('map');
        var mapOptions = {
            zoom: 10,
            center: new google.maps.LatLng(-33.8688, 151.2093)
        };
        map = new google.maps.Map(mapCanvas, mapOptions);
        bounds = new google.maps.LatLngBounds();

        var markerClusterOptions = {
            gridSize: 40,
            maxZoom: 14,
            styles: [{
                width: 53,
                height: 52,
                url: 'https://www.wolfgarten.com.au/static/version1683537897/frontend/Blissmedia/wolf/en_AU/Amasty_Storelocator/images/m1.png',
                textColor: 'white',
                textSize: 12,
                minimumClusterSize: 2
            }]
        };

        markerCluster = new markerClusterer.MarkerClusterer(map, [], markerClusterOptions);

        for (var d = 0, dl = dealers.length; d < dl; d++) {
            var dealer = dealers[d];
            dealer.idx = d;
            var address = dealer.address + ", " + dealer.city + ", " + dealer.postcode + ", " + dealer.state;
            var cachedLocation = getFromLocalStorage(address);
            if (cachedLocation) {
                dealer.latitude = cachedLocation.lat;
                dealer.longitude = cachedLocation.lng;
                addMarker(cachedLocation, dealer.title, dealer);
            } else {
                geocodeDealerAddress(address, dealer);
            }
        }
    }

    function geocodeDealerAddress(address, dealer) {
        geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address: address, componentRestrictions: { country: "NZ" } }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                var location = results[0].geometry.location;
                dealer.latitude = location.lat();
                dealer.longitude = location.lng();
                addToLocalStorage(address, location);
                addMarker(new google.maps.LatLng(dealer.latitude, dealer.longitude), dealer.title, dealer);
            } else {
                console.info('unable to find dealer coordinates', dealer);
            }
        });
    }

    function addToLocalStorage(key, value) {
        if (typeof(Storage) !== "undefined") {
            localStorage.setItem(key, JSON.stringify(value));
        }
    }

    function getFromLocalStorage(key) {
        if (typeof(Storage) !== "undefined") {
            var value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
        }
        return null;
    }


    function dealerInfo(dealers) {
        let info = '';
        $.each(dealers, function (i, v) {
            info += '<div class="dealer-store-desc" data-idx="' + v.idx + '"><div class="dealer-block"><div class="dealer-store-information">';
            info += '<div class="dealer-title">' + v.title + '</div> <br> Address: ' + v.address + ' <br> ' + v.city + ', ' + v.state + ', ' + v.postcode + ' <br> Phone Number: ' + v.phoneNumber + '';
            info += '<br></div></div></div> ';
        });
        $('.dealer-wrapper .dealer-stores-wrapper').html(info);
    }

    function distance(lat1, lon1, lat2, lon2) {
        var p = 0.017453292519943295;
        var c = Math.cos;
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
            c(lat1 * p) * c(lat2 * p) *
            (1 - c((lon2 - lon1) * p)) / 2;
        // console.log("DISTANCE", 12742 * Math.asin(Math.sqrt(a)));
        return 12742 * Math.asin(Math.sqrt(a));
    }

    function setMapOnAll(map) {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(map);
        }
    }

    $(document).on('click', '.dealer-store-desc', function () {
        $('.dealer-store-desc').removeClass('active');
        $(this).addClass('active');
      
        const viewPort = $('.dealer-store-list')[0];
        const dealerStore = $(this)[0];
        if (viewPort.clientHeight + viewPort.scrollTop < dealerStore.offsetTop ||  viewPort.scrollTop > dealerStore.offsetTop) {
            viewPort.scrollTo({top: dealerStore.offsetTop - 10, left: 0, behavior: 'smooth'});
        }
      
        var dealerIndex = $(this).data('idx');
        var dealer = dealers.find(obj => obj.idx === dealerIndex);

        var location = new google.maps.LatLng(dealer.latitude, dealer.longitude);
        map.panTo(location);
        map.setZoom(15);

        // Open the corresponding info window
        var marker = markers.find(obj => obj.idx === dealerIndex);
        if (infoWindow) {
            infoWindow.close();
        }
      
        if (marker) {
            infoWindow = new google.maps.InfoWindow({content: marker.infoWindowContent});
            infoWindow.open(map, marker);
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
      })();
